"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactCookieConsent = _interopRequireDefault(require("react-cookie-consent"));

var _constants = require("../../util/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  if (typeof window !== "undefined") {
    return /*#__PURE__*/_react.default.createElement(_reactCookieConsent.default, {
      location: "bottom",
      buttonText: "Got it!",
      cookieName: "GradifiAcceptCookies",
      disableStyles: true
    }, /*#__PURE__*/_react.default.createElement("span", null, "This site uses cookies to enhance the user experience. ", /*#__PURE__*/_react.default.createElement("a", {
      href: _constants.URLS.MARKETING.PRIVACY_POLICY,
      target: "_blank"
    }, "Privacy Policy")));
  }

  return null;
};

exports.default = _default;